import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "./components/navigation/AppShell";
import { Dashboard } from "./pages/Dashboard";
import { Browse } from "./pages/Browse";
import { Domains } from "./pages/Domains";
import { RecordDetail } from "./pages/RecordDetail";
import { Approvals } from "./pages/Approvals";
import { Lineage } from "./pages/Lineage";
import { Versions } from "./pages/Versions";
import { Hierarchies } from "./pages/Hierarchies";
import { Mappings } from "./pages/Mappings";
import { ApiKeys } from "./pages/ApiKeys";
import { Imports } from "./pages/Imports";
import { Quality } from "./pages/Quality";
import { Settings } from "./pages/Settings";
import { AuditLog } from "./pages/AuditLog";
import { NotFound } from "./pages/NotFound";
import { AboutLayout } from "./pages/about";
import { AboutOverview } from "./pages/about/AboutOverview";
import { AboutRequirements } from "./pages/about/AboutRequirements";
import { AboutArchitecture } from "./pages/about/AboutArchitecture";
import { AboutDataModel } from "./pages/about/AboutDataModel";
import { AboutApi } from "./pages/about/AboutApi";
import { AboutStack } from "./pages/about/AboutStack";
import { AboutChangelog } from "./pages/about/AboutChangelog";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      { path: "home", element: <Dashboard /> },

      // Domain admin
      { path: "domains", element: <Domains /> },

      // Browse a domain (table) and drill into records
      { path: "browse", element: <Navigate to="/browse/instruments" replace /> },
      { path: "browse/:domain", element: <Browse /> },
      { path: "browse/:domain/:recordId", element: <RecordDetail /> },

      { path: "approvals", element: <Approvals /> },
      { path: "approvals/:requestId", element: <Approvals /> },

      { path: "lineage", element: <Lineage /> },
      { path: "lineage/:recordId", element: <Lineage /> },

      { path: "versions/:domain/:recordId", element: <Versions /> },

      { path: "hierarchies", element: <Hierarchies /> },
      { path: "hierarchies/:hierarchyId", element: <Hierarchies /> },

      { path: "mappings", element: <Mappings /> },
      { path: "mappings/:mappingId", element: <Mappings /> },

      { path: "integrations", element: <ApiKeys /> },
      { path: "integrations/:tab", element: <ApiKeys /> },

      { path: "imports", element: <Imports /> },
      { path: "imports/:jobId", element: <Imports /> },

      { path: "quality", element: <Quality /> },
      { path: "quality/:ruleId", element: <Quality /> },

      { path: "audit", element: <AuditLog /> },

      { path: "settings", element: <Settings /> },
      { path: "settings/:tab", element: <Settings /> },

      {
        path: "about",
        element: <AboutLayout />,
        children: [
          { index: true, element: <Navigate to="/about/overview" replace /> },
          { path: "overview", element: <AboutOverview /> },
          { path: "requirements", element: <AboutRequirements /> },
          { path: "architecture", element: <AboutArchitecture /> },
          { path: "data-model", element: <AboutDataModel /> },
          { path: "api", element: <AboutApi /> },
          { path: "stack", element: <AboutStack /> },
          { path: "changelog", element: <AboutChangelog /> },
        ],
      },

      { path: "*", element: <NotFound /> },
    ],
  },
]);
